import {RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     role: 角色权限
 * }
 */

 export const commonRoutes: Array<RouteRecordRaw> = [
    {
      path: '/',
      component: ()=>import('@/views/home/home.vue'),
      meta:{
        title:'首页',
        icon:'dashboard'
      }
    },
    {
      path: '/product/:id',
      component: ()=>import('@/views/product/product.vue'),
      meta:{
        title:'商品详情',
        icon:'dashboard',
        hidden:true, 
        hiddenTab:true
      }
    },
    {
      path: '/product/cashier',
      name:'pay',
      component: ()=>import('@/views/product/pay.vue'),
      meta:{
        title:'支付',
        icon:'dashboard',
        hidden:true, 
        hiddenTab:true
      }
    },
    {
      path: '/product/result',
      component: ()=>import('@/views/product/paySuccess.vue'),
      meta:{
        title:'购买成功',
        icon:'dashboard',
        hidden:true, 
        hiddenTab:true
      }
    },
 
    {
      path: '/:path(.*)*',
      component: ()=>import('@/views/err/404.vue'),
      meta:{
        title:'404',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    }
  ]